module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon7.25cafd84.png";